'use client'
import * as React from 'react'
import Image from 'next/image'
import { tw } from 'utils/classnames'
import { CheckCircleIcon } from 'primitives/icons'

import { FasStarIcon } from '@web/components/icons/fas-start-icon'

export function Review({
  image,
  rating,
  title,
  date,
  copy,
  verifiedPurchaser,
  readMore,
}: {
  image: string
  rating: number
  title: string
  date: string
  copy: string
  verifiedPurchaser: string
  readMore: string
}) {
  const [showAllText, setShowAllText] = React.useState(false)
  const [showReadMoreButton, setShowReadMoreButton] = React.useState(false)

  const copyElement = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    function shouldShowReadMoreButton(element: HTMLDivElement) {
      return element.offsetHeight < element.scrollHeight
    }

    if (copyElement.current) {
      setShowReadMoreButton(shouldShowReadMoreButton(copyElement.current))
    }
  }, [])

  return (
    <div className="text-primary-700 bg-cf-white flex flex-col items-center gap-[10px] border border-[#f0f0f3] p-5 lg:flex-row lg:items-start">
      <Image src={image} width={48} height={48} alt={title} className="size-12 rounded-full" />
      <div className="relative text-left">
        <div className="flex flex-col gap-[2px]">
          <div className="flex w-full items-center gap-5 md:justify-between">
            <h3 className="w-full max-w-[55%] truncate font-bold">{title}</h3>
            <div className="flex w-full max-w-[45%] items-center justify-end font-bold">
              <span className="mr-[6px]">{rating}</span>

              {Array(5)
                .fill(true)
                .map((_, index) => (
                  <FasStarIcon key={index} className="size-4 text-[#FFB400] lg:size-5" />
                ))}
            </div>
          </div>
          <div className="flex w-full items-center gap-5 md:justify-between">
            <p className="text-12 w-full max-w-[55%] text-[#6E7E82]">{date}</p>
            <div className="text-12 w-full max-w-[45%] items-center text-end">
              <CheckCircleIcon className="mr-[6px] inline size-3 flex-shrink-0" />
              {verifiedPurchaser}
            </div>
          </div>
        </div>
        <p
          ref={copyElement}
          className={tw('text-14 mt-[10px] text-left', !showAllText && 'line-clamp-2')}
        >
          {copy}
        </p>
        {!showAllText ? (
          <button
            className={tw(
              "text-[12px] after:absolute after:-inset-3 after:content-['']",
              !showReadMoreButton && 'pointer-events-none opacity-0',
            )}
            onClick={() => setShowAllText(true)}
          >
            {readMore}
          </button>
        ) : null}
      </div>
    </div>
  )
}
